module.exports = __webpack_public_path__ + "img/image9.72dca064.png";